import type { ReactNode } from "react";
import type { EnrichedCheckinItem } from "@/features/checkin/types";
import { timeAgo } from "@/lib/timeAgo";
import { formatQuantityDisplay, getQuantityUnitLabel } from "@/lib/quantity";

export function ReturnHistoryBlock({
  item,
  summary,
  action,
}: {
  item: EnrichedCheckinItem;
  summary: {
    quantity: number;
    supplierName: string;
    requestedAt: string;
    note: string | null;
    statusLabel: string;
  };
  action?: ReactNode;
}) {
  const unitLabel = getQuantityUnitLabel(item.unit_type);

  return (
    <div className="return-history-block">
      <div className="return-history-quantity">
        {formatQuantityDisplay(summary.quantity, item.unit_type)} {unitLabel}
      </div>
      <div className="return-history-content">
        <b>{summary.supplierName}</b>
        <span>
          {timeAgo(summary.requestedAt)}
          {summary.note ? ` · ${summary.note}` : ""}
        </span>
      </div>
      <div className="return-history-status">{summary.statusLabel}</div>
      {action ? <div className="return-history-action">{action}</div> : null}
    </div>
  );
}
